import React from "react";
import { Button, FormGroup, Label, Input, Alert, Spinner } from "reactstrap";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { HomologarPropietarioStore } from "../../../containers/personaReferencia/homologarPropietario/HomologarPropietario.store";
import { HomologarPropietarioDispatcher } from "../../../containers/personaReferencia/homologarPropietario/HomologarPropietario.dispatcher";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { formConfig, Inputs } from "./HomologarPropietario.curp";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

interface Props
  extends HomologarPropietarioStore,
    HomologarPropietarioDispatcher {
  idMembresiaSocio: number;
  idPropietario: number;
  onSuccess: () => void;
  onClose: () => void;
}

interface State {
  curp: string;
}

class HomologarPropietarioComponent extends React.Component<Props, State> {
  state = {
    curp: "",
    verificado: false
  };

  componentWillUnmount() {
    this.props.clearPersonaReferencia();
  }

  handleSubmit = async (values: { [keys in Inputs]: string }) => {
    const curp = values.curp;
    const { idPropietario, getVerificarPropietarioDuplicado } = this.props;
    const preview = await getVerificarPropietarioDuplicado(idPropietario, curp);

    if (preview.fulfilled) {
      this.setState({ curp });
    } else {
      errorNotification(preview.gettingPropietarioDuplicadoError);
    }
  };

  handleConfirm = async () => {
    const { idMembresiaSocio, putHomologarPropietario } = this.props;
    const { curp } = this.state;

    const preview = await putHomologarPropietario(idMembresiaSocio, curp);

    if (preview.fulfilled) {
      successNotification("Propietario homologado exitosamente");
      this.props.onSuccess();
    } else {
      errorNotification(
        preview.puttingHomologarPropietarioError ||
          "Error al homologar propietario"
      );
    }
  };

  render() {
    const {
      puttingHomologarPropietario,
      gettingPropietarioDuplicado,
      propietarioDuplicado
    } = this.props;

    const loading = puttingHomologarPropietario || gettingPropietarioDuplicado;

    return (
      <div>
        {/* Inicio de la pantalla */}
        {!propietarioDuplicado && (
          <Alert color="info" className="mb-3">
            Ingrese la CURP de la persona que remplazará al propietario
          </Alert>
        )}

        {/* Homologación aceptable */}
        {propietarioDuplicado && propietarioDuplicado.aceptable && (
          <Alert color="success" className="mb-3">
            La CURP le pertenece a "{propietarioDuplicado.nombreCurp + '" '}
            (Id Persona {propietarioDuplicado.idPersonaCurp}), confirme el
            remplazo por favor.
          </Alert>
        )}

        {/* Homologación inaceptable, usuario responsable */}
        {propietarioDuplicado && !propietarioDuplicado.aceptable && (
          <Alert color="warning" className="mb-3">
            {propietarioDuplicado.error} ¿Desea continuar aún así?
          </Alert>
        )}

        {/* Formulario de CURP */}
        <div className="container">
          <div style={{ margin: "0 -15px" }}>
            <FormBuilder
              config={formConfig}
              submit={this.handleSubmit}
              processing={loading}
              onChange={() => {
                if (this.props.propietarioDuplicado) {
                  this.props.clearPersonaReferencia();
                }
              }}
            >
              <IButtonBuilder
                name="aceptar"
                onClick={this.handleConfirm}
                disabled={!propietarioDuplicado}
              />
            </FormBuilder>
          </div>
        </div>
      </div>
    );
  }
}

export default HomologarPropietarioComponent;
